import store from "@/store";
import postItem from "@/composables/postItem";
import { revokeNotificationToken } from "@/composables/useFirebaseMessaging";

// clear
function clearCache() {
  (async () => {
    store.commit("loadDashboardFreshSignin", false);
    if (!store.state.user) return;
    await revokeNotificationToken();
    await postItem("authority/logout", {});
    store.commit("loadUser", null);
    store.commit("loadCluster", null);
    store.commit("loadCache", []);
  })();
}

// clear
function clearCacheOnly() {
  store.commit("loadCache", []);
  store.commit("loadDashboardFreshSignin", false);
}

export { clearCache, clearCacheOnly };
